// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
import { border } from '../../tokens/themeColors/border';
import { text } from '../../tokens/themeColors/text';
export var dividerColors = function(mode) {
    var bd = border(mode);
    var tx = text(mode);
    return {
        default: bd.default,
        heavy: bd.heavy,
        // Divider/Active in Figma's Component Colors page — MUI's Divider has no active/selected
        // interactive state to wire this to; consumers apply it directly via sx if needed.
        active: bd.action200,
        soft: bd.soft,
        text: tx.secondary
    };
};

//# sourceMappingURL=dividerColors.js.map